import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Spacer, Typography } from '@emburse/ui-core';
import { ConfirmModal } from '@ReactComponents/ConfirmModal';
export function SignUpDupeModal(props) {
    const { closeModal, onConfirm, isLoading } = props;
    return (
    // our modal is a reverse confirm modal so cancel and confirm are swapped
    _jsxs(ConfirmModal, Object.assign({ headerText: "Potential Duplicate Company", cancelText: "Proceed", confirmText: "Cancel", closeModal: onConfirm, onConfirm: closeModal, isLoading: isLoading }, { children: [_jsxs(Typography, { children: ["A company with this name already exists. Creating another may cause account management issues. Are you sure you want to", ' ', _jsx("strong", { children: "proceed" }), " with creating a duplicate or ", _jsx("strong", { children: "cancel" }), " and review company details?"] }), _jsx(Spacer, { size: 16 })] })));
}
